import { render, staticRenderFns } from "./contest_details.vue?vue&type=template&id=42ff19c3&scoped=true&"
import script from "./contest_details.vue?vue&type=script&lang=js&"
export * from "./contest_details.vue?vue&type=script&lang=js&"
import style0 from "./contest_details.vue?vue&type=style&index=0&id=42ff19c3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ff19c3",
  null
  
)

export default component.exports